module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_5minlab_m.e43f5275b0c7e774600eebac012b9db0.png";